import Form from './components/form_controller';

export default class extends Form {
  dropdownIds = ['changed', 'activities', 'date', 'per_page'];
  static targets = ['form'];

}
